module.exports = __webpack_public_path__ + "static/sopra-c05266330911915438e4eada35c7fe19.jpg";